/**
 * Ponto focal das imagens de capa (Aprendizado).
 *
 * O Admin grava um `object-position` em porcentagem ("50% 30%") por conteúdo,
 * que define o trecho visível quando a capa é recortada em proporções
 * diferentes (card da grade, destaque, faixa de recomendados, leitura).
 *
 * O valor chega da API e é aplicado em `style`, então é revalidado aqui: só o
 * formato "N% N%" (0–100) passa. Qualquer outra coisa cai no centro, que é o
 * comportamento padrão do `object-fit: cover`.
 */
const COVER_POSITION_RE = /^(100|\d{1,2})% (100|\d{1,2})%$/;

export const DEFAULT_COVER_POSITION = '50% 50%';

export function coverPositionStyle(
  position?: string | null
): { objectPosition: string } | undefined {
  if (!position || !COVER_POSITION_RE.test(position)) return undefined;
  return { objectPosition: position };
}
